/* Perhaps we need to make this more specific for the future, in case we have a larger z-index "library",
// but for now on, we can use the one below. 

// There will be scenarios where you might find i.e. 'z-index: ${theme.zIndex.value + 1}', and those
// are for the type of scenarios where we want to have the element above the current element that already has a z-value set. 
// A good example can be found in FAQModalContainer.tsx.
*/

export const zIndex = {
  // General; For miscellaneous or specific scenarios, such as having the Select Menu above content
  general: 1000,

  // Navigation Header
  header: 4000,

  // Modal Containers; meant to be used to have i.e. Terms and Conditions Modal above content
  modal: 5000,

  /* Overlays or Page takeover; meant to be used to have the element above all, 
  // for example: Mobile FAQ Icon, Mobile FAQ Modal, or when opening Mobile Navigation Menu */
  overlay: 3000,
};
